<template>
  <table class="particle-count">
    <thead>
      <tr class="level-one-header">
        <th colspan="9">Particle Count (Particles per 1mL) (ISO 4406/ISO 11500)</th>
      </tr>
      <tr class="level-two-header">
        <th class="sample-number">Lab ID</th>
        <th>ISO Class Code</th>
        <th class="micron"> > 4 (&#956;)</th>
        <th class="micron"> > 6 (&#956;)</th>
        <th class="micron"> > 10 (&#956;)</th>
        <th class="micron"> > 14 (&#956;)</th>
        <th class="micron"> > 25 (&#956;)</th>
        <th class="micron"> > 50 (&#956;)</th>
        <th class="micron"> > 100 (&#956;)</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(sample, index) in sampleData.oilSamples" :key="`Secondary Table Sample ${index}`">
        <td>{{ sample.sampleNumber }}</td>
        <td :class="`severity-id-${sample.isoClassCodeSeverity}`">
          {{ sample.isoClassCode }}
        </td>
        <td :class="`severity-id-${sample.particleCount4Severity}`">
          {{ roundVal(0, true, sample.particleCount4) }}
        </td>
        <td :class="`severity-id-${sample.particleCount6Severity}`">
          {{ roundVal(0, true, sample.particleCount6) }}
        </td>
        <td :class="`severity-id-${sample.particleCount10Severity}`">
          {{ roundVal(0, true, sample.particleCount10) }}
        </td>
        <td :class="`severity-id-${sample.particleCount14Severity}`">
          {{ roundVal(0, true, sample.particleCount14) }}
        </td>
        <td :class="`severity-id-${sample.particleCount25To50Severity}`">
          {{ roundVal(0, true, sample.particleCount25) }}
        </td>
        <td :class="`severity-id-${sample.particleCount50Severity}`">
          {{ roundVal(0, true, sample.particleCount50) }}
        </td>
        <td :class="`severity-id-${sample.particleCount100Severity}`">
          {{ roundVal(0, true, sample.particleCount100) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import RoundingMixin from '../../shared/RoundingMixin';
export default {
  name: 'OilSampleReportAnalysis',
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  },
  mixins: [RoundingMixin]
};
</script>
